import { render } from "./ClinicalCase.vue?vue&type=template&id=2bca5ffb&scoped=true"
import script from "./ClinicalCase.vue?vue&type=script&lang=js"
export * from "./ClinicalCase.vue?vue&type=script&lang=js"

import "./ClinicalCase.vue?vue&type=style&index=0&id=2bca5ffb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bca5ffb"]])

export default __exports__